/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlShareTokenRouteImport } from './routes/sl.$shareToken'
import { Route as RShareTokenRouteImport } from './routes/r.$shareToken'
import { Route as LegalLayoutRouteImport } from './routes/legal/_layout'
import { Route as InterviewTokenRouteImport } from './routes/interview.$token'
import { Route as AppAuthRouteImport } from './routes/_app/_auth'
import { Route as LegalLayoutTermsRouteImport } from './routes/legal/_layout.terms'
import { Route as LegalLayoutSubprocessorsRouteImport } from './routes/legal/_layout.subprocessors'
import { Route as LegalLayoutPrivacyRouteImport } from './routes/legal/_layout.privacy'
import { Route as LegalLayoutDpaRouteImport } from './routes/legal/_layout.dpa'
import { Route as LegalLayoutCookiesRouteImport } from './routes/legal/_layout.cookies'
import { Route as AppLoginLayoutRouteImport } from './routes/_app/login/_layout'
import { Route as AppLoginLayoutIndexRouteImport } from './routes/_app/login/_layout.index'
import { Route as AppAuthOnboardingLayoutRouteImport } from './routes/_app/_auth/onboarding/_layout'
import { Route as AppAuthDashboardLayoutRouteImport } from './routes/_app/_auth/dashboard/_layout'
import { Route as AppAuthDashboardLayoutIndexRouteImport } from './routes/_app/_auth/dashboard/_layout.index'
import { Route as AppAuthOnboardingLayoutUsernameRouteImport } from './routes/_app/_auth/onboarding/_layout.username'
import { Route as AppAuthDashboardLayoutTimeToHireRouteImport } from './routes/_app/_auth/dashboard/_layout.time-to-hire'
import { Route as AppAuthDashboardLayoutTemplatesRouteImport } from './routes/_app/_auth/dashboard/_layout.templates'
import { Route as AppAuthDashboardLayoutSettingsRouteImport } from './routes/_app/_auth/dashboard/_layout.settings'
import { Route as AppAuthDashboardLayoutReferralsRouteImport } from './routes/_app/_auth/dashboard/_layout.referrals'
import { Route as AppAuthDashboardLayoutQuestionBankRouteImport } from './routes/_app/_auth/dashboard/_layout.question-bank'
import { Route as AppAuthDashboardLayoutPipelineReportRouteImport } from './routes/_app/_auth/dashboard/_layout.pipeline-report'
import { Route as AppAuthDashboardLayoutJobsRouteImport } from './routes/_app/_auth/dashboard/_layout.jobs'
import { Route as AppAuthDashboardLayoutCheckoutRouteImport } from './routes/_app/_auth/dashboard/_layout.checkout'
import { Route as AppAuthDashboardLayoutCandidatesRouteImport } from './routes/_app/_auth/dashboard/_layout.candidates'
import { Route as AppAuthDashboardLayoutSettingsIndexRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.index'
import { Route as AppAuthDashboardLayoutJobsIndexRouteImport } from './routes/_app/_auth/dashboard/_layout.jobs.index'
import { Route as AppAuthDashboardLayoutSettingsTeamRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.team'
import { Route as AppAuthDashboardLayoutSettingsTagsRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.tags'
import { Route as AppAuthDashboardLayoutSettingsRejectReasonsRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.reject-reasons'
import { Route as AppAuthDashboardLayoutSettingsOrganisationRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.organisation'
import { Route as AppAuthDashboardLayoutSettingsNotificationsRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.notifications'
import { Route as AppAuthDashboardLayoutSettingsMessageTemplatesRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.message-templates'
import { Route as AppAuthDashboardLayoutSettingsBrandingRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.branding'
import { Route as AppAuthDashboardLayoutSettingsBillingRouteImport } from './routes/_app/_auth/dashboard/_layout.settings.billing'
import { Route as AppAuthDashboardLayoutJobsNewRouteImport } from './routes/_app/_auth/dashboard/_layout.jobs.new'
import { Route as AppAuthDashboardLayoutJobsJobIdRouteImport } from './routes/_app/_auth/dashboard/_layout.jobs.$jobId'
import { Route as AppAuthDashboardLayoutInterviewsInterviewIdRouteImport } from './routes/_app/_auth/dashboard/_layout.interviews.$interviewId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SlShareTokenRoute = SlShareTokenRouteImport.update({
  id: '/sl/$shareToken',
  path: '/sl/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const RShareTokenRoute = RShareTokenRouteImport.update({
  id: '/r/$shareToken',
  path: '/r/$shareToken',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalLayoutRoute = LegalLayoutRouteImport.update({
  id: '/legal/_layout',
  path: '/legal',
  getParentRoute: () => rootRouteImport,
} as any)
const InterviewTokenRoute = InterviewTokenRouteImport.update({
  id: '/interview/$token',
  path: '/interview/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAuthRoute = AppAuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => AppRoute,
} as any)
const LegalLayoutTermsRoute = LegalLayoutTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LegalLayoutRoute,
} as any)
const LegalLayoutSubprocessorsRoute =
  LegalLayoutSubprocessorsRouteImport.update({
    id: '/subprocessors',
    path: '/subprocessors',
    getParentRoute: () => LegalLayoutRoute,
  } as any)
const LegalLayoutPrivacyRoute = LegalLayoutPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => LegalLayoutRoute,
} as any)
const LegalLayoutDpaRoute = LegalLayoutDpaRouteImport.update({
  id: '/dpa',
  path: '/dpa',
  getParentRoute: () => LegalLayoutRoute,
} as any)
const LegalLayoutCookiesRoute = LegalLayoutCookiesRouteImport.update({
  id: '/cookies',
  path: '/cookies',
  getParentRoute: () => LegalLayoutRoute,
} as any)
const AppLoginLayoutRoute = AppLoginLayoutRouteImport.update({
  id: '/login/_layout',
  path: '/login',
  getParentRoute: () => AppRoute,
} as any)
const AppLoginLayoutIndexRoute = AppLoginLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppLoginLayoutRoute,
} as any)
const AppAuthOnboardingLayoutRoute = AppAuthOnboardingLayoutRouteImport.update({
  id: '/onboarding/_layout',
  path: '/onboarding',
  getParentRoute: () => AppAuthRoute,
} as any)
const AppAuthDashboardLayoutRoute = AppAuthDashboardLayoutRouteImport.update({
  id: '/dashboard/_layout',
  path: '/dashboard',
  getParentRoute: () => AppAuthRoute,
} as any)
const AppAuthDashboardLayoutIndexRoute =
  AppAuthDashboardLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthOnboardingLayoutUsernameRoute =
  AppAuthOnboardingLayoutUsernameRouteImport.update({
    id: '/username',
    path: '/username',
    getParentRoute: () => AppAuthOnboardingLayoutRoute,
  } as any)
const AppAuthDashboardLayoutTimeToHireRoute =
  AppAuthDashboardLayoutTimeToHireRouteImport.update({
    id: '/time-to-hire',
    path: '/time-to-hire',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutTemplatesRoute =
  AppAuthDashboardLayoutTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutSettingsRoute =
  AppAuthDashboardLayoutSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutReferralsRoute =
  AppAuthDashboardLayoutReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutQuestionBankRoute =
  AppAuthDashboardLayoutQuestionBankRouteImport.update({
    id: '/question-bank',
    path: '/question-bank',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutPipelineReportRoute =
  AppAuthDashboardLayoutPipelineReportRouteImport.update({
    id: '/pipeline-report',
    path: '/pipeline-report',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutJobsRoute =
  AppAuthDashboardLayoutJobsRouteImport.update({
    id: '/jobs',
    path: '/jobs',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutCheckoutRoute =
  AppAuthDashboardLayoutCheckoutRouteImport.update({
    id: '/checkout',
    path: '/checkout',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutCandidatesRoute =
  AppAuthDashboardLayoutCandidatesRouteImport.update({
    id: '/candidates',
    path: '/candidates',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)
const AppAuthDashboardLayoutSettingsIndexRoute =
  AppAuthDashboardLayoutSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutJobsIndexRoute =
  AppAuthDashboardLayoutJobsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAuthDashboardLayoutJobsRoute,
  } as any)
const AppAuthDashboardLayoutSettingsTeamRoute =
  AppAuthDashboardLayoutSettingsTeamRouteImport.update({
    id: '/team',
    path: '/team',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutSettingsTagsRoute =
  AppAuthDashboardLayoutSettingsTagsRouteImport.update({
    id: '/tags',
    path: '/tags',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutSettingsRejectReasonsRoute =
  AppAuthDashboardLayoutSettingsRejectReasonsRouteImport.update({
    id: '/reject-reasons',
    path: '/reject-reasons',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutSettingsOrganisationRoute =
  AppAuthDashboardLayoutSettingsOrganisationRouteImport.update({
    id: '/organisation',
    path: '/organisation',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutSettingsNotificationsRoute =
  AppAuthDashboardLayoutSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutSettingsMessageTemplatesRoute =
  AppAuthDashboardLayoutSettingsMessageTemplatesRouteImport.update({
    id: '/message-templates',
    path: '/message-templates',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutSettingsBrandingRoute =
  AppAuthDashboardLayoutSettingsBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutSettingsBillingRoute =
  AppAuthDashboardLayoutSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppAuthDashboardLayoutSettingsRoute,
  } as any)
const AppAuthDashboardLayoutJobsNewRoute =
  AppAuthDashboardLayoutJobsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppAuthDashboardLayoutJobsRoute,
  } as any)
const AppAuthDashboardLayoutJobsJobIdRoute =
  AppAuthDashboardLayoutJobsJobIdRouteImport.update({
    id: '/$jobId',
    path: '/$jobId',
    getParentRoute: () => AppAuthDashboardLayoutJobsRoute,
  } as any)
const AppAuthDashboardLayoutInterviewsInterviewIdRoute =
  AppAuthDashboardLayoutInterviewsInterviewIdRouteImport.update({
    id: '/interviews/$interviewId',
    path: '/interviews/$interviewId',
    getParentRoute: () => AppAuthDashboardLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/interview/$token': typeof InterviewTokenRoute
  '/legal': typeof LegalLayoutRouteWithChildren
  '/r/$shareToken': typeof RShareTokenRoute
  '/sl/$shareToken': typeof SlShareTokenRoute
  '/login': typeof AppLoginLayoutRouteWithChildren
  '/legal/cookies': typeof LegalLayoutCookiesRoute
  '/legal/dpa': typeof LegalLayoutDpaRoute
  '/legal/privacy': typeof LegalLayoutPrivacyRoute
  '/legal/subprocessors': typeof LegalLayoutSubprocessorsRoute
  '/legal/terms': typeof LegalLayoutTermsRoute
  '/dashboard': typeof AppAuthDashboardLayoutRouteWithChildren
  '/onboarding': typeof AppAuthOnboardingLayoutRouteWithChildren
  '/login/': typeof AppLoginLayoutIndexRoute
  '/dashboard/candidates': typeof AppAuthDashboardLayoutCandidatesRoute
  '/dashboard/checkout': typeof AppAuthDashboardLayoutCheckoutRoute
  '/dashboard/jobs': typeof AppAuthDashboardLayoutJobsRouteWithChildren
  '/dashboard/pipeline-report': typeof AppAuthDashboardLayoutPipelineReportRoute
  '/dashboard/question-bank': typeof AppAuthDashboardLayoutQuestionBankRoute
  '/dashboard/referrals': typeof AppAuthDashboardLayoutReferralsRoute
  '/dashboard/settings': typeof AppAuthDashboardLayoutSettingsRouteWithChildren
  '/dashboard/templates': typeof AppAuthDashboardLayoutTemplatesRoute
  '/dashboard/time-to-hire': typeof AppAuthDashboardLayoutTimeToHireRoute
  '/onboarding/username': typeof AppAuthOnboardingLayoutUsernameRoute
  '/dashboard/': typeof AppAuthDashboardLayoutIndexRoute
  '/dashboard/interviews/$interviewId': typeof AppAuthDashboardLayoutInterviewsInterviewIdRoute
  '/dashboard/jobs/$jobId': typeof AppAuthDashboardLayoutJobsJobIdRoute
  '/dashboard/jobs/new': typeof AppAuthDashboardLayoutJobsNewRoute
  '/dashboard/settings/billing': typeof AppAuthDashboardLayoutSettingsBillingRoute
  '/dashboard/settings/branding': typeof AppAuthDashboardLayoutSettingsBrandingRoute
  '/dashboard/settings/message-templates': typeof AppAuthDashboardLayoutSettingsMessageTemplatesRoute
  '/dashboard/settings/notifications': typeof AppAuthDashboardLayoutSettingsNotificationsRoute
  '/dashboard/settings/organisation': typeof AppAuthDashboardLayoutSettingsOrganisationRoute
  '/dashboard/settings/reject-reasons': typeof AppAuthDashboardLayoutSettingsRejectReasonsRoute
  '/dashboard/settings/tags': typeof AppAuthDashboardLayoutSettingsTagsRoute
  '/dashboard/settings/team': typeof AppAuthDashboardLayoutSettingsTeamRoute
  '/dashboard/jobs/': typeof AppAuthDashboardLayoutJobsIndexRoute
  '/dashboard/settings/': typeof AppAuthDashboardLayoutSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/interview/$token': typeof InterviewTokenRoute
  '/legal': typeof LegalLayoutRouteWithChildren
  '/r/$shareToken': typeof RShareTokenRoute
  '/sl/$shareToken': typeof SlShareTokenRoute
  '/legal/cookies': typeof LegalLayoutCookiesRoute
  '/legal/dpa': typeof LegalLayoutDpaRoute
  '/legal/privacy': typeof LegalLayoutPrivacyRoute
  '/legal/subprocessors': typeof LegalLayoutSubprocessorsRoute
  '/legal/terms': typeof LegalLayoutTermsRoute
  '/onboarding': typeof AppAuthOnboardingLayoutRouteWithChildren
  '/login': typeof AppLoginLayoutIndexRoute
  '/dashboard/candidates': typeof AppAuthDashboardLayoutCandidatesRoute
  '/dashboard/checkout': typeof AppAuthDashboardLayoutCheckoutRoute
  '/dashboard/pipeline-report': typeof AppAuthDashboardLayoutPipelineReportRoute
  '/dashboard/question-bank': typeof AppAuthDashboardLayoutQuestionBankRoute
  '/dashboard/referrals': typeof AppAuthDashboardLayoutReferralsRoute
  '/dashboard/templates': typeof AppAuthDashboardLayoutTemplatesRoute
  '/dashboard/time-to-hire': typeof AppAuthDashboardLayoutTimeToHireRoute
  '/onboarding/username': typeof AppAuthOnboardingLayoutUsernameRoute
  '/dashboard': typeof AppAuthDashboardLayoutIndexRoute
  '/dashboard/interviews/$interviewId': typeof AppAuthDashboardLayoutInterviewsInterviewIdRoute
  '/dashboard/jobs/$jobId': typeof AppAuthDashboardLayoutJobsJobIdRoute
  '/dashboard/jobs/new': typeof AppAuthDashboardLayoutJobsNewRoute
  '/dashboard/settings/billing': typeof AppAuthDashboardLayoutSettingsBillingRoute
  '/dashboard/settings/branding': typeof AppAuthDashboardLayoutSettingsBrandingRoute
  '/dashboard/settings/message-templates': typeof AppAuthDashboardLayoutSettingsMessageTemplatesRoute
  '/dashboard/settings/notifications': typeof AppAuthDashboardLayoutSettingsNotificationsRoute
  '/dashboard/settings/organisation': typeof AppAuthDashboardLayoutSettingsOrganisationRoute
  '/dashboard/settings/reject-reasons': typeof AppAuthDashboardLayoutSettingsRejectReasonsRoute
  '/dashboard/settings/tags': typeof AppAuthDashboardLayoutSettingsTagsRoute
  '/dashboard/settings/team': typeof AppAuthDashboardLayoutSettingsTeamRoute
  '/dashboard/jobs': typeof AppAuthDashboardLayoutJobsIndexRoute
  '/dashboard/settings': typeof AppAuthDashboardLayoutSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_app/_auth': typeof AppAuthRouteWithChildren
  '/interview/$token': typeof InterviewTokenRoute
  '/legal/_layout': typeof LegalLayoutRouteWithChildren
  '/r/$shareToken': typeof RShareTokenRoute
  '/sl/$shareToken': typeof SlShareTokenRoute
  '/_app/login/_layout': typeof AppLoginLayoutRouteWithChildren
  '/legal/_layout/cookies': typeof LegalLayoutCookiesRoute
  '/legal/_layout/dpa': typeof LegalLayoutDpaRoute
  '/legal/_layout/privacy': typeof LegalLayoutPrivacyRoute
  '/legal/_layout/subprocessors': typeof LegalLayoutSubprocessorsRoute
  '/legal/_layout/terms': typeof LegalLayoutTermsRoute
  '/_app/_auth/dashboard/_layout': typeof AppAuthDashboardLayoutRouteWithChildren
  '/_app/_auth/onboarding/_layout': typeof AppAuthOnboardingLayoutRouteWithChildren
  '/_app/login/_layout/': typeof AppLoginLayoutIndexRoute
  '/_app/_auth/dashboard/_layout/candidates': typeof AppAuthDashboardLayoutCandidatesRoute
  '/_app/_auth/dashboard/_layout/checkout': typeof AppAuthDashboardLayoutCheckoutRoute
  '/_app/_auth/dashboard/_layout/jobs': typeof AppAuthDashboardLayoutJobsRouteWithChildren
  '/_app/_auth/dashboard/_layout/pipeline-report': typeof AppAuthDashboardLayoutPipelineReportRoute
  '/_app/_auth/dashboard/_layout/question-bank': typeof AppAuthDashboardLayoutQuestionBankRoute
  '/_app/_auth/dashboard/_layout/referrals': typeof AppAuthDashboardLayoutReferralsRoute
  '/_app/_auth/dashboard/_layout/settings': typeof AppAuthDashboardLayoutSettingsRouteWithChildren
  '/_app/_auth/dashboard/_layout/templates': typeof AppAuthDashboardLayoutTemplatesRoute
  '/_app/_auth/dashboard/_layout/time-to-hire': typeof AppAuthDashboardLayoutTimeToHireRoute
  '/_app/_auth/onboarding/_layout/username': typeof AppAuthOnboardingLayoutUsernameRoute
  '/_app/_auth/dashboard/_layout/': typeof AppAuthDashboardLayoutIndexRoute
  '/_app/_auth/dashboard/_layout/interviews/$interviewId': typeof AppAuthDashboardLayoutInterviewsInterviewIdRoute
  '/_app/_auth/dashboard/_layout/jobs/$jobId': typeof AppAuthDashboardLayoutJobsJobIdRoute
  '/_app/_auth/dashboard/_layout/jobs/new': typeof AppAuthDashboardLayoutJobsNewRoute
  '/_app/_auth/dashboard/_layout/settings/billing': typeof AppAuthDashboardLayoutSettingsBillingRoute
  '/_app/_auth/dashboard/_layout/settings/branding': typeof AppAuthDashboardLayoutSettingsBrandingRoute
  '/_app/_auth/dashboard/_layout/settings/message-templates': typeof AppAuthDashboardLayoutSettingsMessageTemplatesRoute
  '/_app/_auth/dashboard/_layout/settings/notifications': typeof AppAuthDashboardLayoutSettingsNotificationsRoute
  '/_app/_auth/dashboard/_layout/settings/organisation': typeof AppAuthDashboardLayoutSettingsOrganisationRoute
  '/_app/_auth/dashboard/_layout/settings/reject-reasons': typeof AppAuthDashboardLayoutSettingsRejectReasonsRoute
  '/_app/_auth/dashboard/_layout/settings/tags': typeof AppAuthDashboardLayoutSettingsTagsRoute
  '/_app/_auth/dashboard/_layout/settings/team': typeof AppAuthDashboardLayoutSettingsTeamRoute
  '/_app/_auth/dashboard/_layout/jobs/': typeof AppAuthDashboardLayoutJobsIndexRoute
  '/_app/_auth/dashboard/_layout/settings/': typeof AppAuthDashboardLayoutSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/interview/$token'
    | '/legal'
    | '/r/$shareToken'
    | '/sl/$shareToken'
    | '/login'
    | '/legal/cookies'
    | '/legal/dpa'
    | '/legal/privacy'
    | '/legal/subprocessors'
    | '/legal/terms'
    | '/dashboard'
    | '/onboarding'
    | '/login/'
    | '/dashboard/candidates'
    | '/dashboard/checkout'
    | '/dashboard/jobs'
    | '/dashboard/pipeline-report'
    | '/dashboard/question-bank'
    | '/dashboard/referrals'
    | '/dashboard/settings'
    | '/dashboard/templates'
    | '/dashboard/time-to-hire'
    | '/onboarding/username'
    | '/dashboard/'
    | '/dashboard/interviews/$interviewId'
    | '/dashboard/jobs/$jobId'
    | '/dashboard/jobs/new'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/branding'
    | '/dashboard/settings/message-templates'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/organisation'
    | '/dashboard/settings/reject-reasons'
    | '/dashboard/settings/tags'
    | '/dashboard/settings/team'
    | '/dashboard/jobs/'
    | '/dashboard/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/interview/$token'
    | '/legal'
    | '/r/$shareToken'
    | '/sl/$shareToken'
    | '/legal/cookies'
    | '/legal/dpa'
    | '/legal/privacy'
    | '/legal/subprocessors'
    | '/legal/terms'
    | '/onboarding'
    | '/login'
    | '/dashboard/candidates'
    | '/dashboard/checkout'
    | '/dashboard/pipeline-report'
    | '/dashboard/question-bank'
    | '/dashboard/referrals'
    | '/dashboard/templates'
    | '/dashboard/time-to-hire'
    | '/onboarding/username'
    | '/dashboard'
    | '/dashboard/interviews/$interviewId'
    | '/dashboard/jobs/$jobId'
    | '/dashboard/jobs/new'
    | '/dashboard/settings/billing'
    | '/dashboard/settings/branding'
    | '/dashboard/settings/message-templates'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/organisation'
    | '/dashboard/settings/reject-reasons'
    | '/dashboard/settings/tags'
    | '/dashboard/settings/team'
    | '/dashboard/jobs'
    | '/dashboard/settings'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_app/_auth'
    | '/interview/$token'
    | '/legal/_layout'
    | '/r/$shareToken'
    | '/sl/$shareToken'
    | '/_app/login/_layout'
    | '/legal/_layout/cookies'
    | '/legal/_layout/dpa'
    | '/legal/_layout/privacy'
    | '/legal/_layout/subprocessors'
    | '/legal/_layout/terms'
    | '/_app/_auth/dashboard/_layout'
    | '/_app/_auth/onboarding/_layout'
    | '/_app/login/_layout/'
    | '/_app/_auth/dashboard/_layout/candidates'
    | '/_app/_auth/dashboard/_layout/checkout'
    | '/_app/_auth/dashboard/_layout/jobs'
    | '/_app/_auth/dashboard/_layout/pipeline-report'
    | '/_app/_auth/dashboard/_layout/question-bank'
    | '/_app/_auth/dashboard/_layout/referrals'
    | '/_app/_auth/dashboard/_layout/settings'
    | '/_app/_auth/dashboard/_layout/templates'
    | '/_app/_auth/dashboard/_layout/time-to-hire'
    | '/_app/_auth/onboarding/_layout/username'
    | '/_app/_auth/dashboard/_layout/'
    | '/_app/_auth/dashboard/_layout/interviews/$interviewId'
    | '/_app/_auth/dashboard/_layout/jobs/$jobId'
    | '/_app/_auth/dashboard/_layout/jobs/new'
    | '/_app/_auth/dashboard/_layout/settings/billing'
    | '/_app/_auth/dashboard/_layout/settings/branding'
    | '/_app/_auth/dashboard/_layout/settings/message-templates'
    | '/_app/_auth/dashboard/_layout/settings/notifications'
    | '/_app/_auth/dashboard/_layout/settings/organisation'
    | '/_app/_auth/dashboard/_layout/settings/reject-reasons'
    | '/_app/_auth/dashboard/_layout/settings/tags'
    | '/_app/_auth/dashboard/_layout/settings/team'
    | '/_app/_auth/dashboard/_layout/jobs/'
    | '/_app/_auth/dashboard/_layout/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  InterviewTokenRoute: typeof InterviewTokenRoute
  LegalLayoutRoute: typeof LegalLayoutRouteWithChildren
  RShareTokenRoute: typeof RShareTokenRoute
  SlShareTokenRoute: typeof SlShareTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sl/$shareToken': {
      id: '/sl/$shareToken'
      path: '/sl/$shareToken'
      fullPath: '/sl/$shareToken'
      preLoaderRoute: typeof SlShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$shareToken': {
      id: '/r/$shareToken'
      path: '/r/$shareToken'
      fullPath: '/r/$shareToken'
      preLoaderRoute: typeof RShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal/_layout': {
      id: '/legal/_layout'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof LegalLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/interview/$token': {
      id: '/interview/$token'
      path: '/interview/$token'
      fullPath: '/interview/$token'
      preLoaderRoute: typeof InterviewTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/_auth': {
      id: '/_app/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppAuthRouteImport
      parentRoute: typeof AppRoute
    }
    '/legal/_layout/terms': {
      id: '/legal/_layout/terms'
      path: '/terms'
      fullPath: '/legal/terms'
      preLoaderRoute: typeof LegalLayoutTermsRouteImport
      parentRoute: typeof LegalLayoutRoute
    }
    '/legal/_layout/subprocessors': {
      id: '/legal/_layout/subprocessors'
      path: '/subprocessors'
      fullPath: '/legal/subprocessors'
      preLoaderRoute: typeof LegalLayoutSubprocessorsRouteImport
      parentRoute: typeof LegalLayoutRoute
    }
    '/legal/_layout/privacy': {
      id: '/legal/_layout/privacy'
      path: '/privacy'
      fullPath: '/legal/privacy'
      preLoaderRoute: typeof LegalLayoutPrivacyRouteImport
      parentRoute: typeof LegalLayoutRoute
    }
    '/legal/_layout/dpa': {
      id: '/legal/_layout/dpa'
      path: '/dpa'
      fullPath: '/legal/dpa'
      preLoaderRoute: typeof LegalLayoutDpaRouteImport
      parentRoute: typeof LegalLayoutRoute
    }
    '/legal/_layout/cookies': {
      id: '/legal/_layout/cookies'
      path: '/cookies'
      fullPath: '/legal/cookies'
      preLoaderRoute: typeof LegalLayoutCookiesRouteImport
      parentRoute: typeof LegalLayoutRoute
    }
    '/_app/login/_layout': {
      id: '/_app/login/_layout'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AppLoginLayoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/login/_layout/': {
      id: '/_app/login/_layout/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof AppLoginLayoutIndexRouteImport
      parentRoute: typeof AppLoginLayoutRoute
    }
    '/_app/_auth/onboarding/_layout': {
      id: '/_app/_auth/onboarding/_layout'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AppAuthOnboardingLayoutRouteImport
      parentRoute: typeof AppAuthRoute
    }
    '/_app/_auth/dashboard/_layout': {
      id: '/_app/_auth/dashboard/_layout'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppAuthDashboardLayoutRouteImport
      parentRoute: typeof AppAuthRoute
    }
    '/_app/_auth/dashboard/_layout/': {
      id: '/_app/_auth/dashboard/_layout/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppAuthDashboardLayoutIndexRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/onboarding/_layout/username': {
      id: '/_app/_auth/onboarding/_layout/username'
      path: '/username'
      fullPath: '/onboarding/username'
      preLoaderRoute: typeof AppAuthOnboardingLayoutUsernameRouteImport
      parentRoute: typeof AppAuthOnboardingLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/time-to-hire': {
      id: '/_app/_auth/dashboard/_layout/time-to-hire'
      path: '/time-to-hire'
      fullPath: '/dashboard/time-to-hire'
      preLoaderRoute: typeof AppAuthDashboardLayoutTimeToHireRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/templates': {
      id: '/_app/_auth/dashboard/_layout/templates'
      path: '/templates'
      fullPath: '/dashboard/templates'
      preLoaderRoute: typeof AppAuthDashboardLayoutTemplatesRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/settings': {
      id: '/_app/_auth/dashboard/_layout/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/referrals': {
      id: '/_app/_auth/dashboard/_layout/referrals'
      path: '/referrals'
      fullPath: '/dashboard/referrals'
      preLoaderRoute: typeof AppAuthDashboardLayoutReferralsRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/question-bank': {
      id: '/_app/_auth/dashboard/_layout/question-bank'
      path: '/question-bank'
      fullPath: '/dashboard/question-bank'
      preLoaderRoute: typeof AppAuthDashboardLayoutQuestionBankRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/pipeline-report': {
      id: '/_app/_auth/dashboard/_layout/pipeline-report'
      path: '/pipeline-report'
      fullPath: '/dashboard/pipeline-report'
      preLoaderRoute: typeof AppAuthDashboardLayoutPipelineReportRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/jobs': {
      id: '/_app/_auth/dashboard/_layout/jobs'
      path: '/jobs'
      fullPath: '/dashboard/jobs'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/checkout': {
      id: '/_app/_auth/dashboard/_layout/checkout'
      path: '/checkout'
      fullPath: '/dashboard/checkout'
      preLoaderRoute: typeof AppAuthDashboardLayoutCheckoutRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/candidates': {
      id: '/_app/_auth/dashboard/_layout/candidates'
      path: '/candidates'
      fullPath: '/dashboard/candidates'
      preLoaderRoute: typeof AppAuthDashboardLayoutCandidatesRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
    '/_app/_auth/dashboard/_layout/settings/': {
      id: '/_app/_auth/dashboard/_layout/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsIndexRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/jobs/': {
      id: '/_app/_auth/dashboard/_layout/jobs/'
      path: '/'
      fullPath: '/dashboard/jobs/'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsIndexRouteImport
      parentRoute: typeof AppAuthDashboardLayoutJobsRoute
    }
    '/_app/_auth/dashboard/_layout/settings/team': {
      id: '/_app/_auth/dashboard/_layout/settings/team'
      path: '/team'
      fullPath: '/dashboard/settings/team'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsTeamRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/settings/tags': {
      id: '/_app/_auth/dashboard/_layout/settings/tags'
      path: '/tags'
      fullPath: '/dashboard/settings/tags'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsTagsRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/settings/reject-reasons': {
      id: '/_app/_auth/dashboard/_layout/settings/reject-reasons'
      path: '/reject-reasons'
      fullPath: '/dashboard/settings/reject-reasons'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsRejectReasonsRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/settings/organisation': {
      id: '/_app/_auth/dashboard/_layout/settings/organisation'
      path: '/organisation'
      fullPath: '/dashboard/settings/organisation'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsOrganisationRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/settings/notifications': {
      id: '/_app/_auth/dashboard/_layout/settings/notifications'
      path: '/notifications'
      fullPath: '/dashboard/settings/notifications'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsNotificationsRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/settings/message-templates': {
      id: '/_app/_auth/dashboard/_layout/settings/message-templates'
      path: '/message-templates'
      fullPath: '/dashboard/settings/message-templates'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsMessageTemplatesRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/settings/branding': {
      id: '/_app/_auth/dashboard/_layout/settings/branding'
      path: '/branding'
      fullPath: '/dashboard/settings/branding'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsBrandingRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/settings/billing': {
      id: '/_app/_auth/dashboard/_layout/settings/billing'
      path: '/billing'
      fullPath: '/dashboard/settings/billing'
      preLoaderRoute: typeof AppAuthDashboardLayoutSettingsBillingRouteImport
      parentRoute: typeof AppAuthDashboardLayoutSettingsRoute
    }
    '/_app/_auth/dashboard/_layout/jobs/new': {
      id: '/_app/_auth/dashboard/_layout/jobs/new'
      path: '/new'
      fullPath: '/dashboard/jobs/new'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsNewRouteImport
      parentRoute: typeof AppAuthDashboardLayoutJobsRoute
    }
    '/_app/_auth/dashboard/_layout/jobs/$jobId': {
      id: '/_app/_auth/dashboard/_layout/jobs/$jobId'
      path: '/$jobId'
      fullPath: '/dashboard/jobs/$jobId'
      preLoaderRoute: typeof AppAuthDashboardLayoutJobsJobIdRouteImport
      parentRoute: typeof AppAuthDashboardLayoutJobsRoute
    }
    '/_app/_auth/dashboard/_layout/interviews/$interviewId': {
      id: '/_app/_auth/dashboard/_layout/interviews/$interviewId'
      path: '/interviews/$interviewId'
      fullPath: '/dashboard/interviews/$interviewId'
      preLoaderRoute: typeof AppAuthDashboardLayoutInterviewsInterviewIdRouteImport
      parentRoute: typeof AppAuthDashboardLayoutRoute
    }
  }
}

interface AppAuthDashboardLayoutJobsRouteChildren {
  AppAuthDashboardLayoutJobsJobIdRoute: typeof AppAuthDashboardLayoutJobsJobIdRoute
  AppAuthDashboardLayoutJobsNewRoute: typeof AppAuthDashboardLayoutJobsNewRoute
  AppAuthDashboardLayoutJobsIndexRoute: typeof AppAuthDashboardLayoutJobsIndexRoute
}

const AppAuthDashboardLayoutJobsRouteChildren: AppAuthDashboardLayoutJobsRouteChildren =
  {
    AppAuthDashboardLayoutJobsJobIdRoute: AppAuthDashboardLayoutJobsJobIdRoute,
    AppAuthDashboardLayoutJobsNewRoute: AppAuthDashboardLayoutJobsNewRoute,
    AppAuthDashboardLayoutJobsIndexRoute: AppAuthDashboardLayoutJobsIndexRoute,
  }

const AppAuthDashboardLayoutJobsRouteWithChildren =
  AppAuthDashboardLayoutJobsRoute._addFileChildren(
    AppAuthDashboardLayoutJobsRouteChildren,
  )

interface AppAuthDashboardLayoutSettingsRouteChildren {
  AppAuthDashboardLayoutSettingsBillingRoute: typeof AppAuthDashboardLayoutSettingsBillingRoute
  AppAuthDashboardLayoutSettingsBrandingRoute: typeof AppAuthDashboardLayoutSettingsBrandingRoute
  AppAuthDashboardLayoutSettingsMessageTemplatesRoute: typeof AppAuthDashboardLayoutSettingsMessageTemplatesRoute
  AppAuthDashboardLayoutSettingsNotificationsRoute: typeof AppAuthDashboardLayoutSettingsNotificationsRoute
  AppAuthDashboardLayoutSettingsOrganisationRoute: typeof AppAuthDashboardLayoutSettingsOrganisationRoute
  AppAuthDashboardLayoutSettingsRejectReasonsRoute: typeof AppAuthDashboardLayoutSettingsRejectReasonsRoute
  AppAuthDashboardLayoutSettingsTagsRoute: typeof AppAuthDashboardLayoutSettingsTagsRoute
  AppAuthDashboardLayoutSettingsTeamRoute: typeof AppAuthDashboardLayoutSettingsTeamRoute
  AppAuthDashboardLayoutSettingsIndexRoute: typeof AppAuthDashboardLayoutSettingsIndexRoute
}

const AppAuthDashboardLayoutSettingsRouteChildren: AppAuthDashboardLayoutSettingsRouteChildren =
  {
    AppAuthDashboardLayoutSettingsBillingRoute:
      AppAuthDashboardLayoutSettingsBillingRoute,
    AppAuthDashboardLayoutSettingsBrandingRoute:
      AppAuthDashboardLayoutSettingsBrandingRoute,
    AppAuthDashboardLayoutSettingsMessageTemplatesRoute:
      AppAuthDashboardLayoutSettingsMessageTemplatesRoute,
    AppAuthDashboardLayoutSettingsNotificationsRoute:
      AppAuthDashboardLayoutSettingsNotificationsRoute,
    AppAuthDashboardLayoutSettingsOrganisationRoute:
      AppAuthDashboardLayoutSettingsOrganisationRoute,
    AppAuthDashboardLayoutSettingsRejectReasonsRoute:
      AppAuthDashboardLayoutSettingsRejectReasonsRoute,
    AppAuthDashboardLayoutSettingsTagsRoute:
      AppAuthDashboardLayoutSettingsTagsRoute,
    AppAuthDashboardLayoutSettingsTeamRoute:
      AppAuthDashboardLayoutSettingsTeamRoute,
    AppAuthDashboardLayoutSettingsIndexRoute:
      AppAuthDashboardLayoutSettingsIndexRoute,
  }

const AppAuthDashboardLayoutSettingsRouteWithChildren =
  AppAuthDashboardLayoutSettingsRoute._addFileChildren(
    AppAuthDashboardLayoutSettingsRouteChildren,
  )

interface AppAuthDashboardLayoutRouteChildren {
  AppAuthDashboardLayoutCandidatesRoute: typeof AppAuthDashboardLayoutCandidatesRoute
  AppAuthDashboardLayoutCheckoutRoute: typeof AppAuthDashboardLayoutCheckoutRoute
  AppAuthDashboardLayoutJobsRoute: typeof AppAuthDashboardLayoutJobsRouteWithChildren
  AppAuthDashboardLayoutPipelineReportRoute: typeof AppAuthDashboardLayoutPipelineReportRoute
  AppAuthDashboardLayoutQuestionBankRoute: typeof AppAuthDashboardLayoutQuestionBankRoute
  AppAuthDashboardLayoutReferralsRoute: typeof AppAuthDashboardLayoutReferralsRoute
  AppAuthDashboardLayoutSettingsRoute: typeof AppAuthDashboardLayoutSettingsRouteWithChildren
  AppAuthDashboardLayoutTemplatesRoute: typeof AppAuthDashboardLayoutTemplatesRoute
  AppAuthDashboardLayoutTimeToHireRoute: typeof AppAuthDashboardLayoutTimeToHireRoute
  AppAuthDashboardLayoutIndexRoute: typeof AppAuthDashboardLayoutIndexRoute
  AppAuthDashboardLayoutInterviewsInterviewIdRoute: typeof AppAuthDashboardLayoutInterviewsInterviewIdRoute
}

const AppAuthDashboardLayoutRouteChildren: AppAuthDashboardLayoutRouteChildren =
  {
    AppAuthDashboardLayoutCandidatesRoute:
      AppAuthDashboardLayoutCandidatesRoute,
    AppAuthDashboardLayoutCheckoutRoute: AppAuthDashboardLayoutCheckoutRoute,
    AppAuthDashboardLayoutJobsRoute:
      AppAuthDashboardLayoutJobsRouteWithChildren,
    AppAuthDashboardLayoutPipelineReportRoute:
      AppAuthDashboardLayoutPipelineReportRoute,
    AppAuthDashboardLayoutQuestionBankRoute:
      AppAuthDashboardLayoutQuestionBankRoute,
    AppAuthDashboardLayoutReferralsRoute: AppAuthDashboardLayoutReferralsRoute,
    AppAuthDashboardLayoutSettingsRoute:
      AppAuthDashboardLayoutSettingsRouteWithChildren,
    AppAuthDashboardLayoutTemplatesRoute: AppAuthDashboardLayoutTemplatesRoute,
    AppAuthDashboardLayoutTimeToHireRoute:
      AppAuthDashboardLayoutTimeToHireRoute,
    AppAuthDashboardLayoutIndexRoute: AppAuthDashboardLayoutIndexRoute,
    AppAuthDashboardLayoutInterviewsInterviewIdRoute:
      AppAuthDashboardLayoutInterviewsInterviewIdRoute,
  }

const AppAuthDashboardLayoutRouteWithChildren =
  AppAuthDashboardLayoutRoute._addFileChildren(
    AppAuthDashboardLayoutRouteChildren,
  )

interface AppAuthOnboardingLayoutRouteChildren {
  AppAuthOnboardingLayoutUsernameRoute: typeof AppAuthOnboardingLayoutUsernameRoute
}

const AppAuthOnboardingLayoutRouteChildren: AppAuthOnboardingLayoutRouteChildren =
  {
    AppAuthOnboardingLayoutUsernameRoute: AppAuthOnboardingLayoutUsernameRoute,
  }

const AppAuthOnboardingLayoutRouteWithChildren =
  AppAuthOnboardingLayoutRoute._addFileChildren(
    AppAuthOnboardingLayoutRouteChildren,
  )

interface AppAuthRouteChildren {
  AppAuthDashboardLayoutRoute: typeof AppAuthDashboardLayoutRouteWithChildren
  AppAuthOnboardingLayoutRoute: typeof AppAuthOnboardingLayoutRouteWithChildren
}

const AppAuthRouteChildren: AppAuthRouteChildren = {
  AppAuthDashboardLayoutRoute: AppAuthDashboardLayoutRouteWithChildren,
  AppAuthOnboardingLayoutRoute: AppAuthOnboardingLayoutRouteWithChildren,
}

const AppAuthRouteWithChildren =
  AppAuthRoute._addFileChildren(AppAuthRouteChildren)

interface AppLoginLayoutRouteChildren {
  AppLoginLayoutIndexRoute: typeof AppLoginLayoutIndexRoute
}

const AppLoginLayoutRouteChildren: AppLoginLayoutRouteChildren = {
  AppLoginLayoutIndexRoute: AppLoginLayoutIndexRoute,
}

const AppLoginLayoutRouteWithChildren = AppLoginLayoutRoute._addFileChildren(
  AppLoginLayoutRouteChildren,
)

interface AppRouteChildren {
  AppAuthRoute: typeof AppAuthRouteWithChildren
  AppLoginLayoutRoute: typeof AppLoginLayoutRouteWithChildren
}

const AppRouteChildren: AppRouteChildren = {
  AppAuthRoute: AppAuthRouteWithChildren,
  AppLoginLayoutRoute: AppLoginLayoutRouteWithChildren,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface LegalLayoutRouteChildren {
  LegalLayoutCookiesRoute: typeof LegalLayoutCookiesRoute
  LegalLayoutDpaRoute: typeof LegalLayoutDpaRoute
  LegalLayoutPrivacyRoute: typeof LegalLayoutPrivacyRoute
  LegalLayoutSubprocessorsRoute: typeof LegalLayoutSubprocessorsRoute
  LegalLayoutTermsRoute: typeof LegalLayoutTermsRoute
}

const LegalLayoutRouteChildren: LegalLayoutRouteChildren = {
  LegalLayoutCookiesRoute: LegalLayoutCookiesRoute,
  LegalLayoutDpaRoute: LegalLayoutDpaRoute,
  LegalLayoutPrivacyRoute: LegalLayoutPrivacyRoute,
  LegalLayoutSubprocessorsRoute: LegalLayoutSubprocessorsRoute,
  LegalLayoutTermsRoute: LegalLayoutTermsRoute,
}

const LegalLayoutRouteWithChildren = LegalLayoutRoute._addFileChildren(
  LegalLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  InterviewTokenRoute: InterviewTokenRoute,
  LegalLayoutRoute: LegalLayoutRouteWithChildren,
  RShareTokenRoute: RShareTokenRoute,
  SlShareTokenRoute: SlShareTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
